import { handlePickSuggestion } from "@/components/suggestions/useSuggestions";
import { cursorIsActive } from "@/models/CursorModel";
import { WrapperNodeModel } from "@/models/nodes/WrapperNodeModel";

import { splitInlineExpression } from "./splitInlineExpression";

import type { Suggestion } from "@/components/suggestions/types";
import type { DocumentModel } from "@/models/DocumentModel";
import type { InlineNodeModel } from "@/models/nodes/InlineNodeModel";
import type { NodeModel } from "@/models/nodes/types";

type AdjustIndex = (targetNode: InlineNodeModel, targetIndex?: number) => number | undefined;

const noAdjust: AdjustIndex = (_node, index) => index;

export function commitPendingInput(doc: DocumentModel): AdjustIndex {
  if (doc.input.value.length === 0 || !cursorIsActive(doc.cursor) || doc.input.editingNode) {
    return noAdjust;
  }

  const insertionNode = doc.cursor.node;
  const insertionIndex = doc.cursor.index;

  let inserted: NodeModel[] | null = null;

  if (doc.editor.suggestions.activeSuggestion) {
    inserted = handlePickSuggestion(doc, doc.editor.suggestions.activeSuggestion, {
      skipCursorMove: true,
    });
  } else if (doc.cursor.node.parent?.is(WrapperNodeModel)) {
    splitInlineExpression(doc);
    return noAdjust;
  } else {
    const suggestion: Suggestion = {
      type: "single",
      item: {
        type: "plainText",
        symbol: doc.input.value,
      },
      priority: 0,
    };
    inserted = handlePickSuggestion(doc, suggestion, { skipCursorMove: true });
  }

  if (!inserted || insertionIndex === undefined) {
    return noAdjust;
  }

  const count = inserted.length;

  return (targetNode, targetIndex) => {
    if (
      typeof targetIndex === "number" &&
      targetNode === insertionNode &&
      insertionIndex <= targetIndex
    ) {
      return targetIndex + count;
    }

    return targetIndex;
  };
}
